module.exports = __webpack_public_path__ + "static/img/joyLogoL.ab6e8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joyLogoL.png
// module id = bK1i
// module chunks = 0